import React, { useState } from "react";

function AssessmentMarksStatusModal({ title, onClose, modalData }) {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content shadow rounded-4">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body fs-9">
              <table className="table table-bordered custom-table m-0">
                <thead>
                  <tr>
                    {/* <th>Class</th> */}
                    <th>Assessment Type</th>
                    <th>Obtained Score</th>
                    <th>Passing Score (%)</th>
                    <th>Total Score</th>
                    <th>Result Status</th>
                  </tr>
                </thead>
                <tbody>
                  {modalData?.centerClassesAssessmentPlan.map((plan) =>
                    plan.centerAssessmentPlanDetail.map((detail, index) => (
                      <tr key={`${plan.centerClassId}-${detail.id}-${index}`}>
                        {/* <td>{plan.className}</td> */}
                        <td>{detail.assessmentTypeName}</td>
                        <td>{detail.obtainedScore}</td>
                        <td>{detail.passingScorePercentage}</td>
                        <td>{detail.totalScore}</td>
                        <td>
                          {detail.resultStatus === "Pass" ? (
                            <div className="text-success">
                              {detail.resultStatus}
                            </div>
                          ) : (
                            <div className="text-danger">
                              {detail.resultStatus}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              <div className="text-center mt-4">
                <button
                  className="btn btn-primary btn-sm w-100 rounded-pill"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default AssessmentMarksStatusModal;
